// extracted by mini-css-extract-plugin
export default {"experienceItemContainer":"ExperienceItem_experienceItemContainer__erni4","info":"ExperienceItem_info__pscV8","date":"ExperienceItem_date__hKQaM"};